// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1HtoY","colMaxWidth":"Table_colMaxWidth__13sED"};